(function () {
  function initWholesaleContactForm() {
    var formRoot = document.querySelector('.cs_addForm');
    if (!formRoot) return;

    var submitBtn = formRoot.querySelector('.cs_contactButton button');
    var successModal = document.querySelector('.form_success');
    var nameInput = document.getElementById('name');
    var phoneInput = document.getElementById('phone');
    var emailInput = document.getElementById('email');
    var contactForm = formRoot.querySelector('form');

    if (!submitBtn || !successModal || !contactForm) return;

    var emailInvalid = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(\.[a-zA-Z]{2,6})?)$/;

    function setFieldState(selector, isEmpty) {
      var field = formRoot.querySelector(selector);
      if (!field) return;
      field.classList.toggle('noRequired', isEmpty);
    }

    function resetForm() {
      contactForm.reset();
      successModal.classList.remove('form_successFul');
      successModal.style.display = 'none';
    }

    submitBtn.addEventListener('click', function (event) {
      event.preventDefault();

      var name = nameInput ? nameInput.value.trim() : '';
      var phone = phoneInput ? phoneInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';

      setFieldState('.name', name === '');
      setFieldState('.phone', phone === '');
      setFieldState('.email', email === '');

      if (formRoot.querySelector('.noRequired')) return;

      var emailField = formRoot.querySelector('.email');
      if (!emailInvalid.test(email)) {
        if (emailField) emailField.classList.add('invalid');
        return;
      }

      if (emailField) emailField.classList.remove('invalid');
      contactForm.submit();

      successModal.style.display = 'flex';
      window.setTimeout(function () {
        var title = successModal.querySelector('h3');
        var message = successModal.querySelector('p');
        var okButton = successModal.querySelector('button');

        if (title) title.textContent = 'Successfully submitted';
        if (message) {
          message.textContent =
            'The form has been submitted and Peter is expected to respond to you within 8 hours. If you want to communicate via WhatsApp, please click the button above.';
        }

        successModal.classList.add('form_successFul');

        if (okButton) {
          okButton.onclick = resetForm;
        }
      }, 1000);
    });

    var closeIcon = successModal.querySelector('section i');
    if (closeIcon) {
      closeIcon.addEventListener('click', resetForm);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWholesaleContactForm);
  } else {
    initWholesaleContactForm();
  }
})();
